// extracted by mini-css-extract-plugin
export default {"blockStatusTag":"block-status-tag_blockStatusTag__qWBpD","keyBlob":"block-status-tag_keyBlob__yguip","status":"block-status-tag_status__+ihHS"};